import {ErrorReporter} from './ErrorReporter';

export const errorReporter = new ErrorReporter();
